@let isDropdown = variant() === 'dropdown';
<onyx-search
  [(query)]="query"
  [color]="isDropdown ? 'light-gray' : 'white'"
  [size]="isDropdown ? 32 : 40"
></onyx-search>

<div class="list">
  <onyx-icon-button
    class="refresh"
    variant="transparent"
    color="gray"
    [size]="24"
    icon="restart-outlined"
    [onyxTooltip]="`${I18N}.restoreDefaults`"
    (click)="restoreDefaults()"
  ></onyx-icon-button>

  <p class="label f-body-s">
    {{ `${I18N}.visibleColumns` | translate }}
  </p>

  <ul
    cdkDropList
    [cdkDropListSortPredicate]="dropPredicate.bind(this)"
    (cdkDropListDropped)="drop($event)"
  >
    @for (
      column of visibleColumns() | onyxFilter: query() : ['name', 'tooltip'];
      track column.id
    ) {
      <li
        class="item"
        [class.disabled]="column.required"
        cdkDrag
        [cdkDragDisabled]="column.required"
      >
        @if (!column.required) {
          <onyx-icon-button
            variant="transparent"
            color="blue"
            [size]="20"
            icon="delete-outlined"
            (click)="hideColumn(column.id)"
          ></onyx-icon-button>
        } @else {
          <div></div>
        }

        <ng-container
          *ngTemplateOutlet="columnNameTemplate; context: { column }"
        ></ng-container>

        @if (!column.required) {
          <onyx-icon
            class="drag"
            name="drag-vertical-filled"
            [size]="20"
            cdkDragHandle
          ></onyx-icon>
        }
      </li>
    } @empty {
      <li class="item empty f-body-m f-italic">
        {{ `${I18N}.noneMatching` | translate }}
      </li>
    }
  </ul>
</div>

<div class="list">
  <p class="label f-body-s">
    {{ `${I18N}.hiddenColumns` | translate }}
  </p>

  <ul>
    @for (
      column of hiddenColumns() | onyxFilter: query() : ['name', 'tooltip'];
      track column.id
    ) {
      <li
        class="item active"
        tabindex="-1"
        (keydown.space)="showColumn(column)"
        (click)="showColumn(column)"
      >
        <onyx-icon-button
          variant="transparent"
          color="blue"
          [size]="20"
          icon="add-outlined"
        ></onyx-icon-button>

        <ng-container
          *ngTemplateOutlet="columnNameTemplate; context: { column }"
        ></ng-container>
      </li>
    } @empty {
      <li class="item empty f-body-m f-italic">
        {{
          I18N + (hiddenColumns().length ? '.noneMatching' : '.noneHidden')
            | translate
        }}
      </li>
    }
  </ul>
</div>

<ng-template let-column="column" #columnNameTemplate>
  <p
    [innerHTML]="
      column.name || column.tooltip || '' | translate | onyxHighlight: query()
    "
  ></p>
</ng-template>
